<script setup>
import { ref } from 'vue';

const config = useRuntimeConfig()
const url = config.public.apiBase; 
const { addToast } = useToast();
const auth = useAuthStore();

const emit = defineEmits(['close']);

// Track the disabled state
const isHelpDisabled = ref(false);

async function callForHelp() {
  const shopId = auth.shopId;
  const tableId = auth.tableId;

  if (!shopId || !tableId) {
    addToast("Shop or Table information missing. Please scan a QR code.", 'alert-error');
    return;
  }

  // Prevent execution if already disabled
  if (isHelpDisabled.value) return;

  // Disable button immediately to prevent double-clicks during the API request
  isHelpDisabled.value = true;

  try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const response = await $fetch(url+'/user/call-waiter', {
      method: 'POST',
      body: {
        shop_id: shopId,
        shop_table_id: tableId,
      },
      headers: {
        'Accept': 'application/json',
        Authorization: "Bearer " + auth.token,
      }
    });
    addToast("Someone will assist you soon", 'alert-success');
    emit('close');
  } catch (err) {
    // Show Laravel error
    const msg = err.data?.message || 'Request failed';
    addToast(msg, 'alert-error'); 
    isHelpDisabled.value = false; // Re-enable if it failed
  } finally {
    // Re-enable the button after 1 minute (60,000 milliseconds)
    if (isHelpDisabled.value) {
        setTimeout(() => {
          isHelpDisabled.value = false;
        }, 1000);
    }
  }
}
</script>

<template>
  <button 
    v-if="auth.isAuthenticated && auth.shopId && auth.tableId"
    type="button"
    :disabled="isHelpDisabled"
    class="btn btn-ghost btn-circle disabled:opacity-50 disabled:cursor-not-allowed" 
    @click="callForHelp"
  >
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" :class="['size-6', isHelpDisabled ? 'text-gray-400' : 'text-primary']">
      <path stroke-linecap="round" stroke-linejoin="round" d="M10.05 4.575a1.575 1.575 0 1 0-3.15 0v3m3.15-3v-1.5a1.575 1.575 0 0 1 3.15 0v1.5m-3.15 0 .075 5.925m3.075.75V4.575m0 0a1.575 1.575 0 0 1 3.15 0V15M6.9 7.575a1.575 1.575 0 1 0-3.15 0v8.175a6.75 6.75 0 0 0 6.75 6.75h2.018a5.25 5.25 0 0 0 3.712-1.538l1.732-1.732a5.25 5.25 0 0 0 1.538-3.712l.003-2.024a.668.668 0 0 1 .198-.471 1.575 1.575 0 1 0-2.228-2.228 3.818 3.818 0 0 0-1.12 2.687M6.9 7.575V12m6.27 4.318A4.49 4.49 0 0 1 16.35 15m.002 0h-.002" />
    </svg>
  </button>
</template>